<template>
    <div>
        <router-link to="/colours/add"><button class="button is-success">Add New Colour</button></router-link><br /><br />

        <div class="notification is-info" v-if="loading === true">
            <p>Loading colours ...</p>
        </div>

        <div class="notification is-warning" v-if="loading === false && colours.length == 0">
            <p>There are no colours to display</p>
        </div>
        
        <table class="table is-fullwidth is-striped" v-if="loading === false && colours.length > 0">
            <thead>
                <tr>
                    <th>Name</th>
                    <th width="50" v-if="1==2"></th>
                    <th width="50"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in colours" :key="row.id">
                    <td>{{ row.name }}</td>
                    <td v-if="1==2"><button class="button is-small is-danger">Archive</button></td>
                    <td><button class="button is-small is-link" @click="notWorking()">View</button></td>
                </tr>
                
            </tbody>
        </table>
    </div>

</template>

<script>
    import StoneService from '@/services/StoneService.js';
    //import UtilityService from '@/services/UtilityService.js';
    
    export default {
      name: 'AddOrganisation',
        mixins: [],
        data: function () {
            return {
                   loading : false,
                  search: "",
                    API_NAME: process.env.VUE_APP_API_NAME,
                    accessToken: '',
                    colours: []
                   
            }
        },
        methods: {
            
            getColours() {
                this.loading=true;
                StoneService.getColours(this.accessToken)
                .then(
                    (colours => {
                    
                    this.$set(this, "colours", colours);
                    this.loading=false;
                    }).bind(this)
                );
            },
            notWorking() {
                alert('Not yet working')
            }
            
        },
        created() {
            this.getAccessToken()
            .then(() => { 
                this.getColours()
            });
        
        },
    }
</script>